import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { LoginUrlsWrapper } from '../../app/spaces/Login/LoginUrls';
import { SignInLogo } from '../../app/spaces/Login/SignInLogo';
import { ExternalAuthService } from '../../authentication/services/ExternalAuthService';
import { Messages } from '../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { AuthenticationTypeResolutionService } from '../services/AuthenticationTypeResolutionService';
import { LoginPageStyles } from '../styles/LoginPageStyles';

export function SignOutPage() {

  function siteSamlEnabled(): boolean {
    return ServerSettingsUnauthenticated.isSiteSamlEnabled() && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  }

  function getSignOutLink() {
    return AuthenticationTypeResolutionService.isAuthenticationExternal() && !siteSamlEnabled() ?
      ExternalAuthService.getLoginUrl({}) :
      LoginUrlsWrapper.getInstance().signinUrl({});
  }

  function displaySiteSamlSignedOutMessage() {
    if (siteSamlEnabled()) {
      const message = FeatureFlags.siteSamlSLOEnabled ? Messages.siteSamlSingleLogout() : Messages.siteSamlSignOut();
      return (
        <div className="tb-login-msg-container">
          <div className="tb-logout-msg">{message}</div>
        </div>
      );
    }
  }

  return (
    <div className="tb-login">
      <SignInLogo />
      <div className="tb-padded tb-login-title">{Messages.signedOut()}</div>
      {displaySiteSamlSignedOutMessage()}
      <div className='div.tb-button-container'>
        <ButtonWidget buttonType={ButtonType.Outline}
          className={LoginPageStyles.submitButtonStyle}
          tb-test-id="button-signin"
          testId='button-signin'
          id="button-signin"
          onClick={() => WindowLocationService.navigateTo(getSignOutLink())}>
          {Messages.signIn()}
        </ButtonWidget>
      </div>
    </div>
  );
}